import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import ellipseHeaderRight from "../../assets/layoutBackground/elipse-header-right.webp";
import ellipseFooterLeft from "../../assets/layoutBackground/ellipse-footer-left.webp";
import ellipseFooterRight from "../../assets/layoutBackground/ellipse-footer-right.webp";
import ellipseHeaderLeft from "../../assets/layoutBackground/ellipse-header-left.webp";
import ellipseMainBot from "../../assets/layoutBackground/ellipse-main-bot.webp";
import ellipseMainRight from "../../assets/layoutBackground/ellipse-main-right.webp";
import ellipseMainMobile from "../../assets/layoutBackground/ellipse-mobile-main.webp";

import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import WalletModal from "../../pages/connectWallet/wallet";
import {
  currentWalletState,
  setOpenWalletModal,
} from "../../redux/connect-wallet/connectWallet";
import { setThemeMode } from "../../redux/theme/themeSlice";
import { Modal } from "../../components/Modal";
import { useAppStore } from "../../store/appStore";
import { ModalContentSendAssets } from '../../components/Header/components/UserMenu/components/ModalContentSendAssets';
import { ModalContentReceive } from '../../components/Header/components/UserMenu/components/ModalContentReceive';

const LayoutMain = () => {
  const openWallet = useSelector(currentWalletState);
  const dispatch = useDispatch();
  const {isOpenedReceiveModal, setIsOpenedReceiveModal, isOpenedSendModal, setIsOpenedSendModal} = useAppStore();

  const openWalletModal = () => {
    dispatch(setOpenWalletModal(true));
  };

  const closeWalletModal = () => {
    dispatch(setOpenWalletModal(false));
  };

  useLayoutEffect(() => {
    const currentMode = localStorage.getItem("themeMode");
    if (currentMode === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
      dispatch(setThemeMode("light"));
    }
  }, [dispatch]);

  return (
    <div className="bg-lightGrayBlue font-inter relative dark:bg-black overflow-hidden min-h-dvh">
      <div className="relative">
        <Header openWalletModal={openWalletModal} />

        <img
          src={ellipseHeaderRight}
          alt="Ellipse background decoration"
          className="mobile:hidden absolute top-0 right-0"
        />
        <img
          src={ellipseHeaderLeft}
          alt="Ellipse background decoration"
          className="mobile:hidden absolute top-0 left-0 "
        />
        <img
          src={ellipseMainRight}
          alt="Ellipse background decoration"
          className="mobile:hidden absolute right-0 top-0"
        />
        <img
          src={ellipseMainMobile}
          alt="Ellipse background decoration"
          className="absolute md:hidden top-0 w-full"
        />
      </div>
      <main>
        <img
          src={ellipseMainBot}
          alt="Ellipse background decoration"
          className="mobile:hidden absolute top-100 left-0"
        />
        <div className="relative max-w-screen-2xl mx-auto z-10">
          <Outlet />
        </div>
      </main>

      <img
        src={ellipseFooterLeft}
        alt="Ellipse background decoration"
        className="absolute bottom-0 left-0 hidden lg:block"
      />
      <img
        src={ellipseFooterRight}
        alt="Ellipse background decoration"
        className="absolute bottom-0 right-0 hidden lg:block"
      />
      <WalletModal isWalletOpen={openWallet} closeModal={closeWalletModal} />
			
      <Modal isOpened={isOpenedSendModal} onClose={()=> setIsOpenedSendModal(false)}>
        <ModalContentSendAssets />
      </Modal>
      <Modal isOpened={isOpenedReceiveModal} onClose={()=> setIsOpenedReceiveModal(false) }>
        <ModalContentReceive />
      </Modal>
    </div>
  );
};

export default LayoutMain;
